// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"l3-z","displaySixCardTiles":"m3-z"};